export default "__VITE_ASSET__ZudZZHXL__"